export default "__VITE_ASSET__t8e0R0jY__"